import { Row, Col, Container, Card, Table, Modal, Spinner, Button, FormGroup, Form, ButtonGroup } from "react-bootstrap";
import Layout from "../../components/Layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Paginator from "../../components/table/Paginator";
import { useEffect, useRef, useState } from "react";
import receipt_avatar from '../../assets/images/receipt.svg';
import { useDispatch, useSelector } from "react-redux";
import formatCurrency from "../../utils/currencyFormmter";
import dateFormatter from "../../utils/dateFormatter";
import { blockUnblockSalesforceAgent, getMemberSalesforceAgents, getMemberSalesforceDetails, getSalesforceAgents, getSalesforceDetails, PaySalesforceSalary, withdrawSalesforceBalance } from "../../redux/slices/account.service";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import RecordFilter from "../../components/RecordFilter";


const Salesforce = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const isLoaded = useRef(false)
  const { user = {} } = useSelector((state) => state.auth)

  const [modalShow, setModalShow] = useState(false)
  const [salesforce, setSalesforce] = useState({})
  const [results, setResults] = useState([])
  const [analytics, setAnalytics] = useState({})
  const [withdrawal, setWithdrawal] = useState(false)
  const [paginationData, setpaginationData] = useState({next: '', prev: ''})
  const [payload, setPayload] = useState({
      page: 1,
      from_date: '',
      to_date: '',
      status: '',
      download: '',
      filter_by: '',
      sort_by: '',
      filter: ''
  })
  const [loading, setLoading] = useState(false)
  const [showSalaryForm, setSalaryForm] = useState(false)
  const [sweepBalance, setSweepBalance] = useState(false)

  useEffect(() => {
      if(!isLoaded.current) {
          loadSalesForce()
          isLoaded.current = true
      }
  }, [payload.page])

  const loadSalesForce = (download = false) =>  {
      let requestPayload = payload
      if(download) {
          requestPayload.download = 'True'
      }
    //   requestPayload.page = null
      const action = user?.user_type === 'owner' ? getSalesforceAgents : getMemberSalesforceAgents
      setLoading(true)
      dispatch(action(requestPayload)) 
      .then((response) => {
          setPayload((prevState) => ({...prevState, download: ''}))
          if(response.payload?.results) {
            setResults(response.payload.results)
          }
          if(response.payload?.analytics) {
              setAnalytics(response.payload.analytics)
          }

          if(response.payload?.next || response.payload?.previous) {
              const data = {
                  next: response.payload?.next,
                  prev: response.payload?.previous,
              }
              setpaginationData(data)
          }
      })
      .finally(() => setLoading(false))
  }

  const handlePagination = (data) => {
      setPayload({...payload, page: data})
      isLoaded.current = false
  }

  const handleInput = (event) => {
      const { name, value } = event.target
      setPayload((prevState)=> ({...prevState,[name]:value}))
  }

  const fetchSalesforceById = (id) => {
    const action = user?.user_type === 'owner' ? getSalesforceDetails : getMemberSalesforceDetails
      setLoading(true)
      dispatch(action(id))
      .then((response) => {
        if(response?.payload?.success === true) {
          setSalesforce(response.payload?.data)
          setModalShow(true)
        }
      })
      .finally(() => setLoading(false))
  }

  const handleWithdrawal = () => {
    Swal.fire({
      icon: "warning",
      text: "You are about to withdraw from this wallet",
      showCancelButton: true,
      showConfirmButton: true,
    })
    .then((result) => {
      if(result.isConfirmed) {
        let requestPayload = {
            sales_force_id:  salesforce.id,
            pin: payload.pin,
            withdrawal_type: 'individual', //payload.withdrawal_type
            amount: payload.amount
        }

        setLoading(true)
        dispatch(withdrawSalesforceBalance(requestPayload))
        .then((response) => {
          if(response.payload?.success === true) {
            setWithdrawal(false)
            Swal.fire({
              icon: "success",
              text: response.payload?.message || "Withdrawal successful"
            })
          }
          else {
            Swal.fire({
                title: "Error",
                icon: "error",
                text: response.payload?.message || "An error occured"
            })
          }
        })
        .finally(() => setLoading(false))
      }
    })
  }
 
  const handleSalaryPayment = () => {
    Swal.fire({
      icon: "warning",
      text: `You are about to pay ${salesforce.user__first_name+" "+salesforce.user__last_name} ${formatCurrency(payload.amount).with_currency}`,
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtontext: "Yes, Proceed",
      cancelButtonText: "No, Cancel"
    })
    .then((result) => {
      if(result.isConfirmed) {
        const requestPayload = {
            sales_force_id:  salesforce.id,
            amount: payload.amount,
            pin: payload.pin
        }
        setLoading(true)
        dispatch(PaySalesforceSalary(requestPayload))
        .then((response) => {
          if(response.payload?.success === true) {
            setSalaryForm(false)
            Swal.fire({
              icon: "success",
              text: response.payload?.message || "Payment successful"
            })
          }
          else {
            Swal.fire({
                title: "Error",
                icon: "error",
                text: response.payload?.message || "An error occured"
            })
          }
        })
        .finally(() => setLoading(false))
      }
    })
  }

  const initiateWithdrawal = () => {
    if(!salesforce?.wallet_amount || salesforce?.wallet_amount <= 0) {
      Swal.fire({
        icon: "error",
        text: "Insufficient wallet balance to withdraw"
      })
      return
    }
    setModalShow(false)
    setWithdrawal(true)
  }

  const initiateSalaryPayment = () => {
    setModalShow(false)
    setSalaryForm(true)
  }

  const manageSalesperson = (salesperson_id, decision) => {
    const action = decision === 'block' ? 'block' :
     (decision === 'unblock' ? 'unblock' : (decision === 'delete' ? 'delete' : ''));
    let message = `You are about to ${action} this salesperson`;
    if(action === 'delete') {
        message = "This action will permanently delete this salesperson. Do you wish to continue?"
    }
    Swal.fire({
      title: "Warning",
      icon: "warning",
      text: message,
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtontext: "Yes, Proceed",
      cancelButtonText: "No, Cancel"
    })
    .then((result) => {
      if(result.isConfirmed) {
        setLoading(true)
        dispatch(blockUnblockSalesforceAgent({sales_force_id: salesperson_id, action}))
        .then((response) => {
          if(response.payload?.success === true) {
            Swal.fire({
              icon: "success",
              text: response.payload?.message || `Salesperson has been ${action}ed successfully`
            })
            loadSalesForce()
          }
          else {
            Swal.fire({
                title: "Error",
                icon: "error",
                text: response.payload?.message || "An error occured"
            })
          }
        })
        .finally(() => setLoading(false))
      }
    })
  }

  const handleSearch = () => {
    loadSalesForce()
  }

    const sweepSweepBalances = () => {
        Swal.fire({
            icon: "warning",
            text: "This action will empty your wallet balance. Do you wish to continue?",
            showCancelButton: true,
            showConfirmButton: true,
        })
        .then((result) => {
            if(result.isConfirmed) {
            let requestPayload = {
                pin: payload.pin,
                withdrawal_type: 'all'
            }

            setLoading(true)
            dispatch(withdrawSalesforceBalance(requestPayload))
            .then((response) => {
                if(response.payload?.success === true) {
                setWithdrawal(false)
                Swal.fire({
                    icon: "success",
                    text: response.payload?.message || "Withdrawal successful"
                })
                }
                else {
                Swal.fire({
                    title: "Error",
                    icon: "error",
                    text: response.payload?.message || "An error occured"
                })
                }
            })
            .finally(() => setLoading(false))
            }
        })
    }

  return (
      <Layout>
          <Container className="mt-4 px-4 mb-4">
              <Col md={12} className="d-flex align-items-center justify-content-between no-print">
                <h3>Sales Force</h3>
                <div>
                    {
                        user?.user_type === 'owner' ?
                        <Button 
                            type="button" 
                            variant="primary" 
                            size="sm"
                            className="me-2"
                            onClick={ () => setSweepBalance(true) }
                        >
                            Sweep Balance
                        </Button> : null
                    }
                    <Button
                        variant="primary"
                        size="sm"
                        onClick={() => navigate(user?.user_type === 'owner' ? '/sales-force/transactions' : '/members/sales-force/transactions')}
                    >
                        <FontAwesomeIcon icon="chart-simple" /> Transactions History
                    </Button>
                </div>
              </Col>
              {
                  loading ? (
                      <div className="page-loader">
                          <Spinner size="lg" variant="primary"/>
                      </div>
                  ) : null
              }
              <div className="mt-4 no-print">
                  <Row className="data-card mb-3">
                      <Col md={4} sm={12} xs={12} lg={4} className="mb-2">
                          <Card className="border-0 shadow-sm bg--primary">
                              <Card.Body className="d-flex align-items-center gap-3 p-4">
                                  <div className="icon ">
                                      <i className="lni lni-notepad" style={{fontSize: "25px"}}></i>
                                  </div>
                                  <div>
                                      <h5 className="m-0">{formatCurrency(analytics?.total_sales_forces).formatted}</h5>
                                      <p className="m-0">Total Salesforce</p>
                                  </div>
                              </Card.Body>
                          </Card>
                      </Col>
                      <Col md={4} sm={12} xs={12} lg={4} className="mb-2">
                          <Card className="border-0 shadow-sm">
                              <Card.Body className="d-flex align-items-center gap-3 p-4">
                                  <div className="icon bg-light">
                                      <img src={receipt_avatar} alt="receipt" width={25}/>
                                  </div>
                                  <div>
                                      <h5 className="m-0">{formatCurrency(analytics?.total_sales_force_transactions_count).formatted}</h5>
                                      <p className="m-0">Total Transactions</p>
                                  </div>
                              </Card.Body>
                          </Card>
                      </Col>
                      <Col md={4} sm={12} xs={12} lg={4} className="mb-2">
                          <Card className="border-0 shadow-sm bg--secondary">
                              <Card.Body className="d-flex align-items-center gap-3 p-4">
                                  <div className="icon">
                                      <FontAwesomeIcon icon="wallet" style={{fontSize: "25px"}}/>
                                  </div>
                                  <div>
                                      <h5 className="m-0">{formatCurrency(analytics?.total_sales_force_wallet_balance).with_currency}</h5>
                                      <p className="m-0">Wallet Balance</p>
                                  </div>
                              </Card.Body>
                          </Card>
                      </Col>
                      <Col md={3} sm={12} xs={12} lg={4} className="mb-2">
                          <Card className="border-0 shadow-sm bg--secondary">
                              <Card.Body className="d-flex align-items-center gap-3 p-4">
                                  <div className="icon">
                                      <FontAwesomeIcon icon="money-bill" style={{fontSize: "25px"}}/>
                                  </div>
                                  <div>
                                      <h5 className="m-0">{formatCurrency(analytics?.total_sales_force_transactions_amount).with_currency}</h5>
                                      <p className="m-0">Total Transaction</p>
                                  </div>
                              </Card.Body>
                          </Card>
                      </Col>
                      <Col md={4} sm={12} xs={12} lg={4} className="mb-2">
                          <Card className="border-0 shadow-sm bg--primary">
                              <Card.Body className="d-flex align-items-center gap-3 p-4">
                                  <div className="icon">
                                      <FontAwesomeIcon icon="sack-dollar" style={{fontSize: "25px"}}/>
                                  </div>
                                  <div>
                                      <h5 className="m-0">{formatCurrency(analytics?.today_total_sales_force_transactions_amount).with_currency}</h5>
                                      <p className="m-0">Total Sales Today</p>
                                  </div>
                              </Card.Body>
                          </Card>
                      </Col>
                      <Col md={4} sm={12} xs={12} lg={4} className="mb-2">
                          <Card className="border-0 shadow-sm bg--secondary">
                              <Card.Body className="d-flex align-items-center gap-3 p-4">
                                  <div className="icon">
                                      <FontAwesomeIcon icon="sack-dollar" style={{fontSize: "25px"}}/>
                                  </div>
                                  <div>
                                      <h5 className="m-0">{formatCurrency(analytics?.this_month_total_sales_force_transactions_amount).with_currency}</h5>
                                      <p className="m-0">Transactions this month</p>
                                  </div>
                              </Card.Body>
                          </Card>
                      </Col>
                  </Row>
                  <RecordFilter
                      handleInput={handleInput}
                      handleSearchSubmit={handleSearch}
                      params={[
                          {label: 'Name', value: 'name'},
                          {label: 'Email', value: 'email'},
                          {label: 'Phone Number', value: 'mobile'},
                      ]}
                  />
                  <Card className="border-0 shadow-sm">
                      <Card.Body className="table-responsive">
                          <Table size="sm" className="table-color table-stripedd">
                              <thead>
                                  <tr>
                                      <th>First Name</th>
                                      <th>Last Name</th>
                                      <th>Email</th>
                                      <th>Mobile Number</th>
                                      <th>Date Joined</th>
                                      <th>Wallet Balance</th>
                                      <th></th>
                                  </tr>
                              </thead>
                              <tbody>
                                  {
                                      results?.length ? (
                                          results?.map((item, index) => (
                                              <tr key={index}>
                                                  <td>{item.user__first_name}</td>
                                                  <td> {item.user__last_name}</td>
                                                  <td>{item.user__email}</td>
                                                  <td>{item.user__mobile}</td>
                                                  <td>{ dateFormatter(item.user__date_joined) }</td>
                                                  <td>{formatCurrency(item.wallet_amount).with_currency} </td>
                                                  <td>
                                                    <ButtonGroup>
                                                        {
                                                            user?.user_type === 'owner' ? (
                                                                <>
                                                                    <button 
                                                                        type="button" 
                                                                        className="btn-plain btn-sm rounded text-primary" 
                                                                        title="Withdraw Balance"
                                                                        onClick={() => fetchSalesforceById(item.id)}
                                                                    >
                                                                        <FontAwesomeIcon icon="sack-dollar" />
                                                                    </button>
                                                                    <button 
                                                                            type="button" 
                                                                            className="btn-plain btn-sm rounded text-primary" 
                                                                            title="Pay Salary"
                                                                            onClick={() => fetchSalesforceById(item.id)}
                                                                        >
                                                                        <FontAwesomeIcon icon="credit-card" />
                                                                    </button>
                                                                    <button 
                                                                        type="button" 
                                                                        className="btn-plain btn-sm rounded text-danger" 
                                                                        title="Remove Sales force"
                                                                        onClick={ () => manageSalesperson(item.id, 'delete') }
                                                                    >
                                                                        <FontAwesomeIcon icon="trash-can" />
                                                                    </button>
                                                                    {
                                                                        !item.user__account_locked ? (
                                                                        <button 
                                                                            type="button" 
                                                                            className="btn-plain btn-sm rounded text-danger" 
                                                                            title="Block Account"
                                                                            onClick={() => manageSalesperson(item.id, 'block')}
                                                                        >
                                                                            <FontAwesomeIcon icon="lock-open" />
                                                                        </button>
                                                                        ) : (
                                                                        <button 
                                                                            type="button" 
                                                                            className="btn-plain btn-sm rounded text-success" 
                                                                            title="Unblock Account"
                                                                            onClick={() => manageSalesperson(item.id, 'unblock')}
                                                                        >
                                                                            <FontAwesomeIcon icon="lock" />
                                                                        </button>
                                                                        )
                                                                    }
                                                                </>
                                                            ) : null
                                                        }
                                                       <button 
                                                            type="button" 
                                                            className="btn-plain btn-sm rounded text-primary" 
                                                            title="View Details"
                                                            onClick={() => fetchSalesforceById(item.id)}
                                                        >
                                                        <FontAwesomeIcon icon="eye" />
                                                      </button>
                                                      <button 
                                                        type="button" 
                                                        className="btn-plain btn-sm rounded text-secondary" 
                                                        title="View Transactions"
                                                        onClick={() => navigate(user?.user_type === 'owner' ? `/sales-force/transactions/${item.id}` : `/members/sales-force/transactions/${item.id}`)}
                                                      >
                                                        <FontAwesomeIcon icon="chart-simple" />
                                                      </button>
                                                    </ButtonGroup>
                                                  </td>
                                              </tr>
                                          ))
                                      )
                                      : 
                                      (
                                          <tr>
                                              <td colSpan={6} className="text-center text-muted">No data found</td>
                                          </tr>
                                      )
                                  }
                              </tbody>
                          </Table>
                      </Card.Body>
                  </Card>
                  {
                      results?.length ? (
                          <div className="table-responsive mt-2">
                              <Paginator
                                  next={paginationData.next} 
                                  prev={paginationData.prev}
                                  setCurrentPage={ handlePagination }
                              />
                          </div>
                      ) : null
                  }
              </div>

                {/* Pay salary */}
              <Modal 
                  show={showSalaryForm} 
                  onHide={() => setSalaryForm(false)}
                  backdrop="static"
              >
                    <Modal.Header as="h5" className="d-flex justify-content-between py-2">
                        <strong>Pay Salary</strong>
                        <button 
                            type="button" 
                            className="btn-plain bg-primary btn-sm rounded text-white"
                            onClick={() => setSalaryForm(false)}
                        >
                            <FontAwesomeIcon icon="close" />
                        </button>
                    </Modal.Header>
                  <Modal.Body className="p-2" >
                    <Row>
                      <FormGroup as={Col} md={12} className="mb-2">
                        <Form.Label>Amount</Form.Label>
                        <Form.Control
                          required
                          placeholder="0.00"
                          name="amount"
                          onChange={handleInput}
                        />
                      </FormGroup>
                      <FormGroup as={Col} md={12} className="mb-2">
                        <Form.Label>PIN</Form.Label>
                        <Form.Control
                          type="password"
                          required
                          placeholder="Transaction PIN"
                          name="pin"
                          onChange={handleInput}
                        />
                      </FormGroup>
                      {
                        user?.user_type === 'owner' ? 
                            <div className="d-grid gap-2 mt-2">
                                <Button
                                    type="button" 
                                    variant="primary"
                                    onClick={handleSalaryPayment}
                                >
                                    Submit  <Spinner animation={ loading ? "border" : null} role="status" size="sm"></Spinner>
                                </Button>
                            </div>
                        : null
                      }
                    </Row>
                  </Modal.Body>
              </Modal>

              <Modal 
                  show={withdrawal} 
                  onHide={() => setWithdrawal(false)}
                  backdrop="static"
              >
                    <Modal.Header as="h5" className="d-flex justify-content-between py-2">
                        <strong>Balance Withdrawal</strong>
                        <button 
                            type="button" 
                            className="btn-plain bg-primary btn-sm rounded text-white"
                            onClick={() => setWithdrawal(false)}
                        >
                            <FontAwesomeIcon icon="close" />
                        </button>
                    </Modal.Header>
                  <Modal.Body className="p-2" >
                    <Row>
                        <FormGroup as={Col} md={12} className="mb-2">
                            <Form.Label>Amount</Form.Label>
                            <Form.Control
                            required
                            placeholder="0.00"
                            name="amount"
                            onChange={handleInput}
                            />
                        </FormGroup>
                      <FormGroup as={Col} md={12} className="mb-2">
                        <Form.Label>PIN</Form.Label>
                        <Form.Control
                          type="password"
                          required
                          placeholder="Transaction PIN"
                          name="pin"
                          onChange={handleInput}
                        />
                      </FormGroup>
                      {
                        user?.user_type === 'owner' ?
                            <div className="d-grid gap-2 mt-2">
                                <Button
                                    type="button" 
                                    variant="primary"
                                    onClick={handleWithdrawal}
                                >
                                    Submit  <Spinner animation={ loading ? "border" : null} role="status" size="sm"></Spinner>
                                </Button>
                            </div>
                        : null
                      }
                    </Row>
                  </Modal.Body>
              </Modal>

              <Modal 
                  show={modalShow} 
                  onHide={() => setModalShow(false)}
                  backdrop="static"
              >
                  <Modal.Header as="h5" className="d-flex justify-content-end py-2">
                    <button 
                        type="button" 
                        className="btn-plain bg-primary btn-sm rounded text-white"
                        onClick={() => setModalShow(false)}
                    >
                        <FontAwesomeIcon icon="close" />
                    </button>
                  </Modal.Header>
                  <Modal.Body className="p-2" >
                      <div className="invoice px-3 py-0 border border-0">
                          <div className="table-responsive mb-3">
                              <table className="table border-0">
                                  <tbody>
                                      <tr>
                                          <td className="text-primary font-bold text-sm w-50 border-0">
                                              First Name
                                          </td>
                                          <td className="border-0 text-right">
                                              {salesforce?.first_name}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td className="text-primary font-bold text-sm w-50 border-0">
                                              Last Name
                                          </td>
                                          <td className="border-0 text-right">
                                              {salesforce?.last_name}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td className="text-primary font-bold text-sm w-50 border-0">
                                              Email
                                          </td>
                                          <td className="border-0 text-right">
                                              {salesforce?.email}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td className="text-primary font-bold text-sm w-50 border-0">
                                              Date Joined
                                          </td>
                                          <td className="border-0 text-right">
                                              {dateFormatter(salesforce?.date_joined)}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td className="text-primary font-bold text-sm w-50 border-0">
                                              Wallet Balance
                                          </td>
                                          <td className="border-0 text-right">
                                              {formatCurrency(salesforce?.wallet_amount).with_currency}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td className="text-primary font-bold text-sm w-50 border-0">
                                              Wallet Code
                                          </td>
                                          <td className="border-0 text-right">
                                              {salesforce?.virtual_account?.wallet_code}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td className="text-primary font-bold text-sm w-50 border-0">
                                              Bank Name
                                          </td>
                                          <td className="border-0 text-right">
                                              {salesforce?.virtual_account?.bank_name}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td className="text-primary font-bold text-sm w-50 border-0">
                                              Account Name
                                          </td>
                                          <td className="border-0 text-right">
                                              {salesforce?.virtual_account?.account_name}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td className="text-primary font-bold text-sm w-50 border-0">
                                              Account Number
                                          </td>
                                          <td className="border-0 text-right">
                                              {salesforce?.virtual_account?.account_number}
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div>
                      </div>
                  </Modal.Body>
                    {
                        user?.user_type === 'owner' ? 
                            <Modal.Footer>
                                <Button 
                                    type="button" 
                                    variant="primary" 
                                    size="sm"
                                    onClick={ initiateWithdrawal }
                                >
                                    Withdraw Balance
                                </Button>
                                <Button 
                                    type="button" 
                                    variant="outline-primary" 
                                    size="sm"
                                    onClick={ initiateSalaryPayment }
                                >
                                    Pay Salary
                                </Button>
                            </Modal.Footer>
                        : null
                    }
              </Modal>

            {/* Sweep Balance */}
                <Modal 
                  show={sweepBalance} 
                  onHide={() => setSweepBalance(false)}
                  backdrop="static"
                >
                    <Modal.Header as="h5" className="d-flex justify-content-between py-2">
                        <strong>Wallet Balance Withdrawal</strong>
                        <button 
                            type="button" 
                            className="btn-plain bg-primary btn-sm rounded text-white"
                            onClick={() => setSweepBalance(false)}
                        >
                            <FontAwesomeIcon icon="close" />
                        </button>
                    </Modal.Header>
                  <Modal.Body className="p-2" >
                    <Row>
                      <FormGroup as={Col} md={12} className="mb-2">
                        <Form.Label>PIN</Form.Label>
                        <Form.Control
                          type="password"
                          required
                          placeholder="Transaction PIN"
                          name="pin"
                          onChange={handleInput}
                        />
                      </FormGroup>
                      <div className="d-grid gap-2 mt-2">
                          <Button
                              type="button" 
                              variant="primary"
                              onClick={sweepSweepBalances}
                          >
                              Submit  <Spinner animation={ loading ? "border" : null} role="status" size="sm"></Spinner>
                          </Button>
                      </div>
                    </Row>
                  </Modal.Body>
                </Modal>
          </Container>
      </Layout>
  );
}

export default Salesforce;